import { Injectable } from '@angular/core';
import { Subject, ReplaySubject } from 'rxjs';

@Injectable()
export class TemplateSettingDialogService {
    dialogOpen$: Subject<any> = new Subject<any>();
    actionSubject$: Subject<any> = new ReplaySubject<any>(6);
}
